import React, { useEffect } from 'react'
import { Avatar,Box,Button,Card,CircularProgress,CardContent,CardActionArea,CardMedia,Chip,List,
Grid,makeStyles,Typography } from "@material-ui/core";
import { useHistory, useLocation } from 'react-router-dom';

import 'image-overlay-react/dist/index.css'
import CancelIcon from '@material-ui/icons/Cancel';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import axios from 'axios';
import InfiniteScroll from "react-infinite-scroll-component";
import { CategoriesView_Skeleton } from "../Skeleton";

const RecentBlogs = React.lazy(() => import('./RecentBlogs'));

let imgsrc='https://www.opengrowth.com/assets/og/images/category/'
let channel_list=[{"id":"150","img":imgsrc+"big_tech.jpg","keys":"Big Tech and Recent IPOs"},{"id":"142","img":imgsrc+"book_review.jpg","keys":"Book Review"},{"id":"155","img":imgsrc+"climate.jpg" ,"keys":"Climate Risk & ESG Risk"},{"id":"134","img":imgsrc+"collaboration-tools.jpg","keys":"Collaboration Tools"},{"id":"122","img":imgsrc+"courses.jpg" ,"keys":"Courses"},{"id":"152","img":imgsrc+"cryto.jpg","keys":"Crypto Currency"},{"id":"118","img":imgsrc+"drive-sales.jpg" ,"keys":"Drive Sales & CRM"},{"id":"139","img":imgsrc+"edtech.jpg","keys":"EdTech Industry"},{"id":"137","img":imgsrc+"fashion.jpg","keys":"Fashion Industry"},{"id":"121","img":imgsrc+"financial.jpg","keys":"Financials"},{"id":"145","img":imgsrc+"fintech.jpg","keys":"FinTech"},{"id":"138","img":imgsrc+"fitness.jpg","keys":"Fitness and Digital Health"},{"id":"140","img":imgsrc+"food.jpg","keys":"Food Industry"},{"id":"131","img":imgsrc+"future-tech.jpg","keys":"Future Tech"},{"id":"143","img":imgsrc+"incubators.jpg","keys":"Incubators and Accelerators"},{"id":"151","img":imgsrc+"leadership.jpg" ,"keys":"Leadership"},{"id":"156","img":imgsrc+"legal.jpg" ,"keys":"Legal"},{"id":"144","img":imgsrc+"lifestyle.jpg" ,"keys":"Lifestyle Trends"},{"id":"129","img":imgsrc+"marketing.jpg" ,"keys":"Marketing & Branding"},{"id":"154","img":imgsrc+"meditech.png" ,"keys":"MediTech"},{"id":"158","img":imgsrc+"mentorship.jpg" ,"keys":"Mentorship and Coaching"},{"id":"148","img":imgsrc+"product-fit.jpg" ,"keys":"Product-Market Fit"},{"id":"117","img":imgsrc+"raise.jpg" ,"keys":"Raise Capital"},{"id":"146","img":imgsrc+"estate.jpg" ,"keys":"Real Estate and Construction"},{"id":"149","img":imgsrc+"remote.jpg" ,"keys":"Remote Work"},{"id":"141","img":imgsrc+"innovation.jpg" ,"keys":"Social Innovations"},{"id":"135","img":imgsrc+"startup-basic.jpg" ,"keys":"Startup Basics"},{"id":"136","img":imgsrc+"startup-news.jpg" ,"keys":"Startup News"},{"id":"112","img":imgsrc+"team.jpg" ,"keys":"Team Building"},{"id":"157","img":imgsrc+"tech_of_business.jpg" ,"keys":"Technology of Business"},{"id":"153","img":imgsrc+"travel.jpg" ,"keys":"Travel Industry"},{"id":"147","img":imgsrc+"women_en.jpg" ,"keys":"Women Entrepreneurs"}];

const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 6
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2
    }
  };

const styles = {
		  
		   name: { cursor:"pointer",   overflow: "hidden",display: "-webkit-box",
					WebkitLineClamp: 3,WebkitBoxOrient: "vertical" },
					
		   details: { 	   overflow: "hidden",display: "-webkit-box",
					WebkitLineClamp: 5,WebkitBoxOrient: "vertical" },
		  
}

const useStyles = makeStyles((theme) => ({
   media: {
      height: 0,
      paddingTop: '56.25%' // 16:9
   },
   card: {
      position: 'relative',
   },
   overlay: {
	position: 'absolute',
	bottom: 0,
	left: 0,
	width: '100%',
	height: '100%',
	bgcolor: 'rgba(0, 0, 0, 0.54)',
	padding: '10px',
	backgroundImage: 'linear-gradient(to bottom, #b8b9b700, black)'
   },

	small:{width:'64px',height:'64px'},
	text:{color:"#dddddd"}
}));



let og_pah="https://www.opengrowth.com/assets/uploads/images/co_brand_1/article/"


function Channel(props) {
  const [start,setStart ] =React.useState(0);
  const [end, setEnd] =React.useState(10);
  const [hasMore, sethasMore] =React.useState(true);
  const [msg, setMessage] =React.useState(false);
  const [loading, setLoading] =React.useState(true);
  const [, forceUpdate] = React.useState(0);
  const history = useHistory();
  const location = useLocation();

  const [blogs, setBlogs] = React.useState([]);
  const [cat, setCategory] = React.useState("Big Tech and Recent IPOs");
  const classes = useStyles();

  useEffect(() => {
	  let category=cat
	if(![undefined,null,''].includes(location.state))
		{
			setCategory(location.state['category'])
			category=location.state['category']
		}
	setTimeout(() => {
		
		getCachePlay(start,category);
		forceUpdate(n => !n);
		
		}, 500);
		
		
		
  }, [])
 	
	
	
	const view_blogs = (blog) => {
		history.push({
		pathname: "/blogs",
		  state: {
				article:blog
		} })	
	}
	
	const fetchMoreData = () => {
    if(hasMore!=false)
	{
		setTimeout(() => {
			
			setStart(start+end)
			getCachePlay(start+end,cat)
			
			
		}, 1500);
	}}
	
	const getCachePlay = (sta,category) => {
		let url="https://www.opengrowth.com/article-feed?&search=category&id="+category+"&start="+sta+"&end="+end
			
			
		//alert(url)
			
		axios.get(url)
		.then((response) => {
				
				let data=response.data
				//console.log(data)
				//alert(data.length)
					setLoading(false)
					
					
					if(data.length<end )
					{
						sethasMore(false)
					}
					
						//console.log("append")
						//alert(sta)
						if (sta==0)
						{
							setBlogs([]);
							setBlogs(data)
						}
						else{
							setBlogs([...blogs,...data])
						}
						if (data.length==0)
						{
							setMessage(msg)
							setTimeout(() => {
							setMessage(false)	
							}, 1500);
						}

					
					//console.log(blogs)
				
		});	
		
		
	}
	 const get_catrgory_based_data= (title) => {
		
		setBlogs([]);	
		setCategory(title);
		setStart(0)
		sethasMore(true)
		getCachePlay(0,title)
    } 
    const handleDelete= () => {
		get_recent_bogs()		
    } 
   
	const get_recent_bogs= () => {
		
    } 
	 
	 
	const RenderCard=({title,img})=>{
	  return (
	  <Box marginRight={2}>
	  <Card elevation={3} 
	  onClick={()=>{get_catrgory_based_data(title)}}>
	  <CardActionArea >
	  <Box sx={{ position: 'relative' }}>
		<CardMedia
		  component="img"
		  height="150"
		  image={img}
		/>
		<Box className={classes.overlay}>	
		
			<Box display="flex"  
			alignItems= 'flex-end'
			justifyContent= 'center'
			height="100%">
			<Typography 
			variant="subtitle1"
			color="primary">
			<Box fontWeight="bold"
			lineHeight="1.25rem"
			className={classes.text}>{title}</Box>
			</Typography >
			</Box>
			
	  </Box>
	  </Box>
	</CardActionArea>
	</Card>
	</Box>
	)}
	
	const CategoriesList=()=>{
	  return (

	  	<Carousel responsive={responsive} >
		{
		
				channel_list.map((e, index) => (
				
				<RenderCard 
				title={e['keys']}
				img={e['img']}
				/>
				
							
		))}
		</Carousel>
	)}
	
	
	const CategoriesView=()=>{
	  return (
	  <InfiniteScroll style={{overflow:'hidden'}}
			dataLength={blogs.length}
			hasMore={hasMore}
			loader={
				
					hasMore==true?
							<Box marginTop={2} marginBottom={2} alignItems='center'
							display='flex'
							flexDirection='column'
							>
							{
								loading
								  ? <CircularProgress disableShrink />
								  :<Button 
									variant="outlined" 
									size="medium"
									color={"primary"}
									disable={loading}
									onClick={fetchMoreData}>
									Load More
								</Button>
							}
							</Box>
					:
						<CircularProgress disableShrink />  
					  
				
			}
			endMessage={
				<>
				<Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column'}} marginTop={2} marginBottom={2} >
			    <Typography variant="subtitle2" color="textPrimary" >You have seen it all</Typography>
				</Box>
				</>
			}>
				<Box >
				<Grid container spacing={2}>
				{
		
				blogs.map((e, index) => (
				<Grid item xs={12} >
				<List className={classes.root}>
				<BlogsCard article={e} />
				</List>
				</Grid>
							
			))}
			</Grid>
			</Box>
		</InfiniteScroll>
	)}
	
	const BlogsCard = ({article}) => {
			
			let title=article['title']
			let meta_description=article['meta_description']
			if([null,undefined].includes(title)==false)
			{
				title=(article['title']).replaceAll(/[\\\/"]/g, '')
				meta_description=(article['meta_description']).replaceAll(/[\\\/"]/g, '')
			}
	
		return (
					
					<Card elevation={3}>
					<CardContent>
					<Box display="flex" marginBottom={0.5} marginTop={0.5} >
					
					<Box>
					<Avatar src={og_pah+article['blog_image']} className={classes.small} />
					</Box>
					
					<Box marginLeft={2} display="block">
						<Box onClick={()=>view_blogs(article)} sx={{cursor:'pointer'}} 
						display="flex" justifyContent="space-between">
							<Typography variant="subtitle1" color='primary'>
							<Box  fontWeight="600" style={styles.name}>
							{title} |
							</Box>
							</Typography>
							
							<Box marginLeft={1}>
							<Chip style={{height:'auto'}}
							label={
							<Box marginTop={0.5} marginBottom={0.5} fontSize="12px"   fontWeight="600" >
								 {article['category']}
							</Box>
							} color="primary" variant="outlined" /></Box>
				
							
						</Box>
						
						<Box>
						<Typography variant="body2" color='textSecondary'  style={styles.details}>
						{meta_description}
						</Typography >
						</Box>
					</Box>
					</Box>
					</CardContent>
					</Card>
		)}


    return (
	
		<Grid container direction="row"
                    alignItems="center"
                    justify="center" spacing={2} >

			
			<Grid item xs={12} >
			<CategoriesList/>
			</Grid>
			
			
			<Grid item container xs={12} spacing={2} >
				<Grid item xs={12} md={8} >
				<Box display="flex-end"
				padding={2}>
				{cat!=false
				?<Chip 
				label={cat} 
				onDelete={()=>{setCategory(false)}} 
				variant="outlined"
				deleteIcon={<CancelIcon style={{color:"#25387c"}} />}
				/>:""}
				</Box>
				
				
				{
				
					loading==true 
					?
						<CategoriesView_Skeleton/>
					:	
						<CategoriesView />
				}
				</Grid>
			

				<Grid item xs={12} md={4} >
					<RecentBlogs/>
				</Grid>
			</Grid>
		  	
			
		  </Grid>

  );
}

export default Channel;